const tags = [
    {
        "id": "0234a31e-a729-4e28-9d6a-3f87c4966b9e",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Oneshot"
            },
            "description": {},
            "group": "format",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "07251805-a27e-4d59-b488-f0bfbec15168",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Thriller"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "0a39b5a1-b235-4886-a747-1d05d216532d",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Award Winning"
            },
            "description": {},
            "group": "format",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "0bc90acb-ccc1-44ca-a34a-b9f3a73259d0",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Reincarnation"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "256c8bd9-4904-4360-bf4f-508a76d67183",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Sci-Fi"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "292e862b-2d17-4062-90a2-0356caa4ae27",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Time Travel"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "2bd2e8d0-f146-434a-9b51-fc9ff2c5fe6a",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Genderswap"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "2d1f5d56-a1e5-4d0d-a961-2193588b08ec",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Loli"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "31932a7e-5b8e-49a6-9f12-2afa39dc544c",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Traditional Games"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "320831a8-4026-470b-94f6-8353740e6f04",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Official Colored"
            },
            "description": {},
            "group": "format",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "33771934-028e-4cb3-8744-691e866a923e",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Historical"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "36fd93ea-e8b8-445e-b836-358f02b3d33d",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Monsters"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "391b0423-d847-456f-aff0-8b0cfc03066b",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Action"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "39730448-9a5f-48a2-85b0-a70db87b1233",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Demons"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "3b60b75c-a2d7-4860-ab56-05f391bb889c",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Psychological"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "3bb26d85-09d5-4d2e-880c-c34b974339e9",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Ghosts"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "3de8c75d-8ee3-48ff-98ee-e20a65c86451",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Animals"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "3e2b8dae-350e-4ab8-a8ce-016e844b9f0d",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Long Strip"
            },
            "description": {},
            "group": "format",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "423e2eae-a7a2-4a8b-ac03-a8351462d71d",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Romance"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "489dd859-9b61-4c37-af75-5b18e88daafc",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Ninja"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "4d32cc48-9f00-4cca-9b5a-a839f0764984",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Comedy"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "50880a9d-5440-4732-9afb-8f457127e836",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Mecha"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "51d83883-4103-437c-b4b1-731cb73d786c",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Anthology"
            },
            "description": {},
            "group": "format",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "5920b825-4181-4a17-beeb-9918b0ff7a30",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Boys' Love"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "5bd0e105-4481-44ca-b6e7-7544da56b1a3",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Incest"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "5ca48985-9a9d-4bd8-be29-80dc0303db72",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Crime"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "5fff9cde-849c-4d78-aab0-0d52b2ee1d25",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Survival"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "631ef465-9aba-4afb-b0fc-ea10efe274a8",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Zombies"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "65761a2a-415e-47f3-bef2-a9dababba7a6",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Reverse Harem"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "69964a64-2f90-4d33-beeb-f3ed2875eb4c",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Sports"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "7064a261-a137-4d3a-8848-2d385de3a99c",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Superhero"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "799c202e-7daa-44eb-9cf7-8a3c0441531e",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Martial Arts"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "7b2ce280-79ef-4c09-9b58-12b7c23a9b78",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Fan Colored"
            },
            "description": {},
            "group": "format",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "81183756-1453-4c81-aa9e-f6e1b63be016",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Samurai"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "81c836c9-914a-4eca-981a-560dad663e73",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Magical Girls"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "85daba54-a71c-4554-8a28-9901a8b0afad",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Mafia"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "87cc87cd-a395-47af-b27a-93258283bbc6",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Adventure"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "891cf039-b895-47f0-9229-bef4c96eccd4",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Self-Published"
            },
            "description": {},
            "group": "format",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "8c86611e-fab7-4986-9dec-d1a2f44acdd5",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Virtual Reality"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "92d6d951-ca5e-429c-ac78-451071cbf064",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Office Workers"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "9438db5a-7e2a-4ac0-b39e-e0d95a34b8a8",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Video Games"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "9467335a-1b83-4497-9231-765337a00b96",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Post-Apocalyptic"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "97893a4c-12af-4dac-b6be-0dffb353568e",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Sexual Violence"
            },
            "description": {},
            "group": "content",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "9ab53f92-3eed-4e9b-903a-917c86035ee3",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Crossdressing"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "a1f53773-c69a-4ce5-8cab-fffcd90b1565",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Magic"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "a3c67850-4684-404e-9b7f-c69850ee5da6",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Girls' Love"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "aafb99c1-7f60-43fa-b75f-fc9502ce29c7",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Harem"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "ac72833b-c4e9-4878-b9db-6c8a4a99444a",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Military"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "acc803a4-c95a-4c22-86fc-eb6b582d82a2",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Wuxia"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "ace04997-f6bd-436e-b261-779182193d3d",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Isekai"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "b11fda93-8f1d-4bef-b2ed-8803d3733170",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "4-Koma"
            },
            "description": {},
            "group": "format",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "b13b2a48-c720-44a9-9c77-39c9979373fb",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Doujinshi"
            },
            "description": {},
            "group": "format",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "b1e97889-25b4-4258-b28b-cd7f4d28ea9b",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Philosophical"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "b29d6a3d-1569-4e7a-8caf-7557bc92cd5d",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Gore"
            },
            "description": {},
            "group": "content",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "b9af3a63-f058-46de-a9a0-e0c13906197a",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Drama"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "c8cbe35b-1b2b-4a3f-9c37-db84c4514856",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Medical"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "caaa44eb-cd40-4177-b930-79d3ef2afe87",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "School Life"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "cdad7e68-1419-41dd-bdce-27753074a640",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Horror"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "cdc58593-87dd-415e-bbc0-2ec27bf404cc",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Fantasy"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "d14322ac-4d6f-4e9b-afd9-629d5f4d8a41",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Villainess"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "d7d1730f-6eb0-4ba6-9437-602cac38664c",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Vampires"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "da2d50ca-3018-4cc0-ac7a-6b7d472a29ea",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Delinquents"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "dd1f77c5-dea9-4e2b-97ae-224af09caf99",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Monster Girls"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "ddefd648-5140-4e5f-ba18-4eca4071d19b",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Shota"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "df33b754-73a3-4c54-80e6-1a74a8058539",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Police"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "e197df38-d0e7-43b5-9b09-2842d0c326dd",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Web Comic"
            },
            "description": {},
            "group": "format",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "e5301a23-ebd9-49dd-a0cb-2add944c7fe9",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Slice of Life"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "e64f6742-c834-471d-8d72-dd51fc02b835",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Aliens"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "ea2bc92d-1c26-4930-9b7c-d5c0dc1b6869",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Cooking"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "eabc5b4c-6aff-42f3-b657-3e90cbd00b75",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Supernatural"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "ee968100-4191-4968-93d3-f82d72be7e46",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Mystery"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "f4122d1c-3b44-44d0-9936-ff7502c39ad3",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Adaptation"
            },
            "description": {},
            "group": "format",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "f42fbf9e-188a-447b-9fdc-f19dc1e4d685",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Music"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "f5ba408b-0e7a-484d-8d49-4e9125ac96de",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Full Color"
            },
            "description": {},
            "group": "format",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "f8f62932-27da-4fe4-8ee1-6779a8c5edba",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Tragedy"
            },
            "description": {},
            "group": "genre",
            "version": 1
        },
        "relationships": []
    },
    {
        "id": "fad12b5e-68ba-460e-b933-9ae8318f5b65",
        "type": "tag",
        "attributes": {
            "name": {
                "en": "Gyaru"
            },
            "description": {},
            "group": "theme",
            "version": 1
        },
        "relationships": []
    }
]


export default tags